import * as React from "react";
//import styles from './ResponsivePaper.css';
import { v4 } from "uuid";

import { withStyles, WithStyles, createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
//import '../../resources/img/bg1.jpg';
import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import TextField from '@material-ui/core/TextField';

import ExamServer from '../server/ExamServer'

import Activation from './Activation'
import CreateExam from "./CreateExam";
import Hidden from '@material-ui/core/Hidden';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';


const theme = createMuiTheme();

class ResponsivePaper extends React.Component {


    render() {

        const { children } = this.props;

        return (
            <React.Fragment>
                <Hidden xsDown>
                    <Grid container
                        justify="center"
                        alignItems="center"
                        style={{
                            height: "calc(100vh - 200px)"
                        }}
                    >
                        <div>
                        <Paper style={{marginTop:theme.spacing(5), padding :theme.spacing(3)}}>
                            {children}
                        </Paper>
                         
                        </div>
                    </Grid>
                </Hidden>
                <Hidden smUp>
                    {children}
                </Hidden>


            </React.Fragment>


        )
    }
}

export default ResponsivePaper;
